import {inject, Injectable} from '@angular/core';

import {AppConfigPort} from '@features/app-config/application/ports/app-config.port';
import {GetConfigPayloadDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.payload.dto';
import {map, Observable} from 'rxjs';
import {GetConfigResponseDto} from '@features/app-config/application/use_cases/get-config/dto/get-config.response.dto';
import {GetConfigHttpMapper} from '@features/app-config/infrastructure/http/get-config/get-config.http.mapper';
import {
  GetConfigHttpResponseDto
} from '@features/app-config/infrastructure/http/get-config/get-config.http.response.dto';
import {environment} from '@environments/environment.prod';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {HttpHeaders} from '@angular/common/http';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {FilterInterface} from '@core/interfaces/filter/filter.interface';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';

@Injectable()
export class AppConfigHttpAdapter implements AppConfigPort {

  private url = environment.uri;

  private readonly http = inject(ClientHttpPort);

  constructor(
    private readonly localStoragePort: LocalStoragePort,
    private readonly navigationPort: NavigationPort,
  ) {
  }

  public getConfig(payload: GetConfigPayloadDto): Observable<GetConfigResponseDto> {
    const url = window.location.href;
    const {suffix} = this.navigationPort.extractQueryParams(url);
    let suffixDatabase: string | null = null;
    if (!suffix) {
      suffixDatabase = this.localStoragePort.getByKey<string | null>('_suffix');
      if (!suffixDatabase) throw new Error(`Could not find suffix`);
    } else {
      suffixDatabase = suffix;
      this.localStoragePort.setByKey("_suffix", suffixDatabase);
    }
    const filter: FilterInterface = {
      withRelationships: ["company"]
    };
    const headers: HttpHeaders = new HttpHeaders({
      "token": environment.secret_key,
      "x-filter-model": JSON.stringify(filter),
    });
    return this.http.get<GetConfigHttpResponseDto>(`${this.url}company-general-config-list?suffix_database=${suffixDatabase}`, {headers}).pipe(
      map(responseHttp => {
        if (responseHttp.data.length == 0) {
          throw new Error("Could not find company general config");
        } else {
          return GetConfigHttpMapper.toResponse(responseHttp);
        }
      })
    );
  }

}
